export const DEFAULT_IDLE_POPUP_DELAY_MS = 60_000;

export type IdlePopupEvent =
  | 'TIMER_STARTED'
  | 'SUPPRESSED'
  | 'POPUP_SHOWN'
  | 'POPUP_DISMISSED'
  | 'COMPLETED'
  | 'CANCELLED';

export type IdlePopupEventNames = Record<IdlePopupEvent, string>;

/** Vercel Analytics names (snake_case) and GTM dataLayer names (camelCase). */
export type IdlePopupTracking = {
  analytics: IdlePopupEventNames;
  gtm: IdlePopupEventNames;
};

/** localStorage keys. Either one set means the popup never shows again. */
export type IdlePopupStorageKeys = {
  dismissed: string;
  completed: string;
};

export type IdlePopupTrackingData = Record<string, unknown>;

export type UseIdlePopupOptions = {
  storageKeys: IdlePopupStorageKeys;
  tracking: IdlePopupTracking;
  delayMs?: number;
  /** When set, show only after this long with no user activity (any action resets it) instead of `delayMs` after mount. */
  inactivityMs?: number;
  /** Extra fields sent with every event (region, product, variant, …). */
  trackingData?: IdlePopupTrackingData;
  enabled?: boolean;
};

/** Ref handle a page uses to stop a pending popup (e.g. on checkout). */
export type IdlePopupHandle = {
  cancelPopup: () => void;
};

export type IdlePopupControls = {
  isVisible: boolean;
  /** Hide without persisting (e.g. checkout started). */
  cancel: () => void;
  /** User closed it. Persists `dismissed`. */
  dismiss: () => void;
  /** User took the popup's action. Persists `completed` and `dismissed`. */
  complete: () => void;
};
